import AbstractMapper from '@core/utils/mappers/AbstractMapper';

import ILottoFavouritesDto from '@core/mappers/lotto/dtos/ILottoFavouritesDto';

type Favourites = Record<number, number[][]>;

/*
    Maps {
        2: [[1,2,3], [4,5,6]],
        7: [[22,56]]
    }
    To [
        { k: 2, v: ['1,2,3', '4,5,6'] },
        { k: 7, v: ['22,56]}
    ]
    !IMPORTANT When we send to the server we don't do one extra JSON.stringify action on it
*/
export default class LottoFavouritesMapperOut extends AbstractMapper<Favourites, ILottoFavouritesDto> {

    createTargetObject(dto: Favourites): ILottoFavouritesDto {
        const favoruitesDto = Object.entries(dto).map(
            ([k, v]) => ({
                k,
                v: v.map((favs) => favs.join(','))
            })
        );
        return favoruitesDto;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/lotto/LottoFavouriteModelToDtoMapper.ts